(function(){
  var REPORT_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
  var app = document.getElementById('fundraiserDonationApp');
  if (!app) return;

  var phoneInput = document.getElementById('fundraiserPhone');
  var codeInput = document.getElementById('fundraiserCode');
  var requestInput = document.getElementById('fundraiserRequest');
  var dueDateInput = document.getElementById('fundraiserDueDate');
  var sendCodeBtn = document.getElementById('fundraiserSendCodeBtn');
  var verifyBtn = document.getElementById('fundraiserVerifyBtn');
  var submitBtn = document.getElementById('fundraiserSubmitBtn');
  var statusNode = document.getElementById('fundraiserDonationStatus');
  var codeWrap = document.getElementById('fundraiserCodeWrap');
  var formStep = document.getElementById('fundraiserFormStep');
  var verifiedClientCard = document.getElementById('fundraiserVerifiedClient');
  var clientNameNode = document.getElementById('fundraiserClientName');
  var clientMetaNode = document.getElementById('fundraiserClientMeta');

  var state = {
    sending: false,
    verifying: false,
    submitting: false,
    requestId: '',
    clientToken: '',
    client: null
  };

  function normalizeString(value){
    return String(value == null ? '' : value).trim();
  }

  function formatPhone(value){
    var digits = normalizeString(value).replace(/\D+/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6, 10);
  }

  function setStatus(message, tone){
    if (!statusNode) return;
    var text = normalizeString(message);
    if (!text) {
      statusNode.hidden = true;
      statusNode.textContent = '';
      statusNode.removeAttribute('data-tone');
      return;
    }
    statusNode.hidden = false;
    statusNode.textContent = text;
    if (tone) {
      statusNode.setAttribute('data-tone', tone);
    } else {
      statusNode.removeAttribute('data-tone');
    }
  }

  async function proxyRequest(payload){
    var response = await fetch(REPORT_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {})
    });
    var rawText = await response.text();
    var data = null;
    try {
      data = rawText ? JSON.parse(rawText) : null;
    } catch (_error) {
      data = null;
    }
    if (!response.ok || !data || data.ok !== true) {
      throw new Error((data && (data.error || data.message)) || rawText || 'Request failed.');
    }
    return data;
  }

  function updateUI(){
    if (sendCodeBtn) sendCodeBtn.disabled = state.sending || state.verifying || state.submitting;
    if (verifyBtn) verifyBtn.disabled = state.sending || state.verifying || state.submitting;
    if (submitBtn) submitBtn.disabled = state.sending || state.verifying || state.submitting;
    if (codeWrap) codeWrap.hidden = !state.requestId;
    if (formStep) formStep.hidden = !state.clientToken;
    if (verifiedClientCard) verifiedClientCard.hidden = !state.client;

    if (state.client) {
      var name = normalizeString(state.client.name) || 'Verified client';
      var phone = normalizeString(state.client.mobilePhone);
      var email = normalizeString(state.client.email);
      if (clientNameNode) clientNameNode.textContent = name;
      if (clientMetaNode) {
        clientMetaNode.textContent = [formatPhone(phone), email].filter(Boolean).join(' • ');
      }
    }
  }

  async function sendCode(){
    var phone = normalizeString(phoneInput && phoneInput.value);
    if (!phone) {
      throw new Error('Enter your phone number first.');
    }
    state.sending = true;
    updateUI();
    try {
      var data = await proxyRequest({
        action: 'client-auth-start',
        method: 'phone',
        identifier: phone
      });
      state.requestId = normalizeString(data.request_id);
      setStatus(data.note || 'Verification code sent.', 'success');
      updateUI();
      if (codeInput) codeInput.focus();
    } finally {
      state.sending = false;
      updateUI();
    }
  }

  async function verifyCode(){
    var phone = normalizeString(phoneInput && phoneInput.value);
    var code = normalizeString(codeInput && codeInput.value);
    if (!phone) throw new Error('Enter your phone number first.');
    if (!state.requestId) throw new Error('Send a code first.');
    if (!code) throw new Error('Enter the code we texted you.');

    state.verifying = true;
    updateUI();
    try {
      var data = await proxyRequest({
        action: 'client-auth-verify',
        method: 'phone',
        identifier: phone,
        request_id: state.requestId,
        code: code
      });
      state.clientToken = normalizeString(data.client_token);
      state.client = data.client || null;
      if (!state.clientToken || !state.client || !normalizeString(state.client.id)) {
        throw new Error('We could not confirm your Boulevard client account.');
      }
      setStatus('Phone verified. You can submit your request now.', 'success');
      updateUI();
    } finally {
      state.verifying = false;
      updateUI();
    }
  }

  async function submitDonation(){
    var requestDetails = normalizeString(requestInput && requestInput.value);
    var dueDate = normalizeString(dueDateInput && dueDateInput.value);

    if (!state.clientToken || !state.client || !normalizeString(state.client.id)) {
      throw new Error('Verify your phone number first.');
    }
    if (!requestDetails) {
      throw new Error('Tell us what you are looking for and what cause it supports.');
    }
    if (!dueDate) {
      throw new Error('Add a due date so the team knows the timeline.');
    }

    state.submitting = true;
    updateUI();
    try {
      await proxyRequest({
        action: 'fundraiser-donation-submit',
        client_token: state.clientToken,
        request_details: requestDetails,
        due_date: dueDate
      });
      setStatus('Request submitted. The team has the details and your contact information.', 'success');
      if (requestInput) requestInput.value = '';
      if (dueDateInput) dueDateInput.value = '';
    } finally {
      state.submitting = false;
      updateUI();
    }
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', function(){
      phoneInput.value = formatPhone(phoneInput.value);
    });
  }

  if (sendCodeBtn) {
    sendCodeBtn.addEventListener('click', async function(){
      try {
        await sendCode();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }

  if (verifyBtn) {
    verifyBtn.addEventListener('click', async function(){
      try {
        await verifyCode();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', async function(){
      try {
        await submitDonation();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }

  updateUI();
})();
